import { createEffect, Match, Switch, type Component } from 'solid-js';
import { Dynamic } from 'solid-js/web';
import { Notice } from '@academy/ui';
import { useSession } from '../context/session';
import { PageHeader } from '../components/PageHeader';
import { recordNavigationAuthorization } from '../services/navigation-telemetry';
import { hasRouteCapability, type RouteCapability } from './route-access';

export const RouteAuthorization = (props: {
  capability: RouteCapability;
  component: Component;
}) => {
  const session = useSession();
  const authorizationStartedAt = performance.now();
  let lastRecordedStatus: string | null = null;
  createEffect(() => {
    const status = session.capabilityStatus();
    if (status === 'invalidated' || status === lastRecordedStatus) return;
    lastRecordedStatus = status;
    recordNavigationAuthorization(performance.now() - authorizationStartedAt);
  });
  return (
    <Switch>
      <Match when={session.capabilityStatus() === 'invalidated'}>
        <p role="status" aria-live="polite">
          Verifying current workspace access…
        </p>
      </Match>
      <Match when={hasRouteCapability(session.roles, props.capability)}>
        <Dynamic component={props.component} />
      </Match>
      <Match when>
        <>
          <PageHeader
            eyebrow="Access control"
            title="This workspace is not available to your current account."
            description="Direct links use the same role capability boundary as navigation. Record-level access remains enforced by the server."
          />
          <Notice tone="error" title="Access denied">
            Your effective academy roles do not grant this workspace capability.
          </Notice>
        </>
      </Match>
    </Switch>
  );
};
